/**
 * useFeatureNav — 기능 페이지로 이동.
 *
 * 정책(2026-06): 사용량 한도 초과여도 **진입은 허용**한다.
 *   - 과거 생성 기록 조회·다운로드 등은 한도와 무관하게 가능해야 하기 때문.
 *   - 생성(신규 사용)은 각 기능 페이지에서 useFeatureBlocked 로 **생성 버튼을 비활성화**해 차단한다.
 *   - 한도 안내는 페이지의 FeatureUsageBadge("소진" + 업그레이드 링크)가 담당.
 * 이전에는 여기서 navigate 를 막고 모달을 띄웠으나, 진입 자체를 막아 기록 조회가 불가능했던 문제를 해소.
 *
 * 사용 예:
 *   const goTo = useFeatureNav()
 *   <button onClick={(e) => goTo(e, 'jsa', '/dashboard/jsa')}>JSA</button>
 *   <NavLink to="/dashboard/jsa" onClick={(e) => goTo(e, 'jsa', '/dashboard/jsa')}>...</NavLink>
 */
import { useCallback } from 'react'
import { useNavigate, type NavigateOptions } from 'react-router-dom'

// 라우트 → backend Feature 키 매핑 (사이드바 등에서 라우트만 알 때 사용).
export const ROUTE_FEATURE_MAP: Record<string, string> = {
  '/dashboard/jsa':                'jsa',
  '/dashboard/chatbot':            'chat',
  '/dashboard/tbm':                'tbm',
  '/dashboard/image-analysis':     'image_analysis',
  '/dashboard/corrective':         'corrective',
  '/dashboard/risk-assessment':    'risk_assessment',
  '/dashboard/work-permit':        'work_permit',
  '/dashboard/work-timing':        'work_timing',
  '/dashboard/accident-report':    'accident_report',
  '/dashboard/safety-education':   'safety_education_pptx',
  '/dashboard/eta':                'eta',
  '/dashboard/fta':                'fta',
  '/dashboard/safety-cost':        'safety_cost',
  '/dashboard/equipment-cert':     'equipment_cert',
}

export function useFeatureNav() {
  const navigate = useNavigate()

  return useCallback(
    (e: React.MouseEvent | undefined, _feature: string, to: string, options?: NavigateOptions) => {
      // 한도 초과여도 진입 허용 — 차단하지 않는다(생성은 페이지 버튼에서 막음).
      // NavLink(e 있음): preventDefault 하지 않아 정상 이동. 버튼(e 없음): 직접 navigate.
      if (!e) navigate(to, options)
    },
    [navigate],
  )
}
